import { toRefs } from '@vueuse/core'
import type { BookingExpandedDetails, Nullable } from '~/types'

/**
 * Returns the Booking object from the state with a bunch of helpers/checks.
 *
 * @param newBookingDetails The new booking details to set
 * @returns The booking details
 */
export default function useBookingDetails(newBookingDetails?: Ref<Nullable<BookingExpandedDetails>>) {
  const booking = useSelectedBookingDetails()

  if (newBookingDetails !== undefined) {
    watch(newBookingDetails, () => {
      booking.value = newBookingDetails.value
    }, {
      immediate: true,
    })
  }

  return {
    ...toRefs(computed(() => getBookingDetails(booking.value))),
    ...toRefs(computed(() => getFinancial(booking.value?.Financial))),
    ...toRefs(computed(() => getRvSnapshot(booking.value?.RVSnapshot))),
  }
}
